import React from 'react'

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PlusCircle, Upload, ChevronUp, Table, Grid } from 'react-feather';
import { ImageWithBasePath } from 'Core/components';
import { useDispatch, useSelector } from 'react-redux';
import { actions as mainActions, showModal } from 'Core/redux/main/slice';
import { actions as receivingActions } from './store/slice';
import { selectTileView } from './store/selectors';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { all_routes } from '../../router/all_routes';

const { setToogleHeader } = mainActions;
const { setTileView } = receivingActions;
const { MOLDRECEIVING_ADD_EDIT } = MODAL_TYPES;

const MoldReceivingTopHead = () => {
    const dispatch = useDispatch();
    const data = useSelector(isHeaderVisible);
    const tileView = useSelector(selectTileView);
  
    const renderExcelTooltip = props => <Tooltip {...props}>Excel</Tooltip>;
    const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;
    const renderTileViewTooltip = props => (
      <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
    );
  
    const isMoldReceivingScreen = window.location.pathname == all_routes.shipments;
  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="collapse-header"
              className={data ? 'active' : ''}
              onClick={() => {
                dispatch(setToogleHeader(!data));
              }}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={() => {
                dispatch(setTileView(!tileView));
              }}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>
      {!isMoldReceivingScreen && (
        <div className="d-flex purchase-pg-btn">
          <div className="page-btn">
            <Link
              to="#"
              className="btn btn-added"
              onClick={() => {
                dispatch(showModal(MOLDRECEIVING_ADD_EDIT));
              }}
            >
              <PlusCircle className="me-2" />
              Add New Mold
            </Link>
          </div>
          {/* <div className="page-btn import">
            <Link
              to="#"
              className="btn btn-added color"
              data-bs-toggle="modal"
              data-bs-target="#view-notes"
            >
              <Upload className="me-2" />
              Upload Shipments
            </Link>
          </div> */}
        </div>
      )}
    </>
  )
}

export default MoldReceivingTopHead